module.exports = __webpack_public_path__ + "img/map-validator.298487e1.svg";